<template>
  <div v-if="isLocalOpen" class="info-block">
    <div class="title">
      <div class="title-text">
        <p>Теперь вы можете выбрать ТОП - экспертов</p>
      </div>
    </div>
    <p class="subtitle">
      Для вашего проекта недостаточно Middle +, Senior? Выберите специалиста из сегмента
      Premium
    </p>
    <div class="button" @click="close()">Понятно</div>
  </div>
</template>

<script>
import SvgIcon from "@/components/base/SvgIcon";
import BaseButton from "@/components/base/BaseButton";
export default {
  name: "InfoBlock",
  components: { SvgIcon, BaseButton },
  data() {
    return {
      isLocalOpen: true,
    };
  },
  computed: {},
  methods: {
    async close() {
      this.isLocalOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/vuetify_variables";

.info-block {
  height: auto;
  display: flex;
  position: relative;
  margin: 12px;
  width: auto;
  border-radius: 18px;
  border-radius: 18px;
  background: linear-gradient(104deg, #42434e 37.57%, #5a7758 63.25%, #7fc666 100.79%);
  color: white;
  padding: 20px;
}

.title {
  display: flex;
  justify-content: space-between;
  font-family: Muller;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 124%;
  width: 100%;
  padding-bottom: 12px;

  @include sm {
    padding-bottom: 8px;
    font-size: 15px;
  }
}

.actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 12px;

  @include sm {
    padding-bottom: 0px;
  }
}

.title-text {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.subtitle {
  font-family: SFProDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 124%;
  padding-bottom: 20px;

  @include sm() {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
    text-align: left !important;
    gap: 10px;
    font-size: 13px;
    padding-bottom: 0px;
  }
}

.close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.button {
  cursor: pointer;
  margin-top: 12px;
  display: flex;
  display: flex;
  width: 314px;
  height: 32px;
  padding: 5px 14px 5px 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  background: #fff;
  color: #42434e;
  text-align: center;
  font-family: Muller;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.channel-name {
  position: absolute;
  right: 20px;
  bottom: 20px;
  color: #fff;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 124%;
  opacity: 0.4;

  @include sm() {
    display: none;
  }
}

.arrow-mobile {
  display: none;

  @include sm() {
    cursor: pointer;
    display: flex;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: #ffffff33;
    align-items: center;
    padding: 10px;
    padding-left: 7px;
  }
}

.mobile {
  display: none;

  @include sm() {
    display: block;
  }
}
</style>
